import { stripPhoneNumberInputValue } from '@service-initiation/shared-utils-helpers';

export const stripValue = (fieldName: string, str: string) =>
  fieldName === 'phoneNumber' ? stripPhoneNumberInputValue(str) : str;
